import type { ReactNode } from "react";

import { initials } from "./styles";

/**
 * The frame of a list page (W12 U4): title with a count, actions on the
 * right, a toolbar line, and the content in a white card.
 */
export function ListPage({
  title,
  count,
  actions,
  toolbar,
  children,
  footer,
}: {
  title: string;
  count?: number;
  actions?: ReactNode;
  toolbar?: ReactNode;
  children: ReactNode;
  footer?: ReactNode;
}) {
  return (
    <div className="space-y-4">
      <div className="flex flex-wrap items-center justify-between gap-3">
        <div className="flex items-baseline gap-3">
          <h1 className="text-2xl font-semibold tracking-tight">{title}</h1>
          {count !== undefined ? (
            <span className="text-sm text-muted-foreground">
              {count.toLocaleString()}
            </span>
          ) : null}
        </div>
        {actions ? (
          <div className="flex items-center gap-2">{actions}</div>
        ) : null}
      </div>
      {toolbar ? (
        <div className="flex flex-wrap items-center gap-2">{toolbar}</div>
      ) : null}
      <div className="overflow-hidden rounded-xl border bg-card shadow-xs">
        {children}
      </div>
      {footer ? (
        <p className="text-sm text-muted-foreground">{footer}</p>
      ) : null}
    </div>
  );
}

/** A small initials avatar for table rows. */
export function RowAvatar({
  name,
  square = false,
}: {
  name: string;
  square?: boolean;
}) {
  return (
    <span
      aria-hidden
      className={
        "flex size-8 shrink-0 items-center justify-center bg-muted text-xs font-semibold text-muted-foreground " +
        (square ? "rounded-md" : "rounded-full")
      }
    >
      {initials(name)}
    </span>
  );
}
